import React from "react";
import MarketingHeader from "../components/marketing/MarketingHeader";
import Footer from "../components/marketing/Footer";

const AboutPage = () => (
  <div className="min-h-screen bg-slate-50">
    <MarketingHeader />
    <section className="bg-slate-900 py-14 text-white sm:py-20">
      <div className="marketing-container max-w-4xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-3">About Us</div>
        <h1 className="font-heading text-4xl font-bold tracking-tight md:text-6xl">
          Empowering India's next generation of professionals.
        </h1>
      </div>
    </section>
    <section className="section-padding">
      <div className="marketing-container max-w-4xl">
        <div className="prose prose-slate max-w-none">
          <p className="text-base leading-8 text-slate-600 sm:text-lg">
            Kampus Campanion is a professional internship management platform built specifically for Indian college students. We bridge the gap between classroom learning and industry-ready skills through structured 120-hour internship programs.
          </p>
          <h3 className="font-heading text-2xl font-bold text-slate-900 mt-10">Our Mission</h3>
          <p className="text-slate-600 leading-relaxed">
            To make high-quality, verifiable internship experiences accessible to every student in India, regardless of their college, location, or background.
          </p>
          <h3 className="font-heading text-2xl font-bold text-slate-900 mt-10">Our Values</h3>
          <ul className="text-slate-600 leading-relaxed space-y-2">
            <li><strong>Transparency:</strong> Every certificate is publicly verifiable.</li>
            <li><strong>Rigor:</strong> Programs are aligned with UGC, NEP-2020, and AICTE frameworks.</li>
            <li><strong>Accessibility:</strong> Online-first, mobile-friendly, affordable pricing.</li>
            <li><strong>Outcomes:</strong> We measure success by your skills, not just attendance.</li>
          </ul>
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default AboutPage;

